import { render, staticRenderFns } from "./AppTaskCreate.vue?vue&type=template&id=5866c4d0"
import script from "./AppTaskCreate.vue?vue&type=script&lang=js"
export * from "./AppTaskCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports